import Vue from 'vue'

// load transitions
import FadeScaleTransition from '@/transitions/fade-scale-transition'
import ExpandTransition from '@/transitions/expand-transition'

// available globally
Vue.component('fade-scale-transition', FadeScaleTransition)
Vue.component('expand-transition', ExpandTransition)
